interface ConnectionStatusProps {
  isConnected: boolean
  connectionUptime?: number
  className?: string
}

export function ConnectionStatus({
  isConnected,
  connectionUptime,
  className = ''
}: ConnectionStatusProps) {
  return (
    <div className={`flex items-center gap-3 bg-white/90 backdrop-blur-sm rounded-full px-4 py-2 shadow-lg border border-gray-200 ${className}`}>
      <div className={`w-3 h-3 rounded-full ${isConnected ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`}></div>
      <span className="text-sm font-bold text-gray-700">
        {isConnected ? 'מחובר בזמן אמת' : 'מנותק'}
      </span>
      {isConnected && connectionUptime !== undefined && connectionUptime > 0 && (
        <span className="text-xs text-gray-500">
          ({Math.floor(connectionUptime / 60)}:{String(connectionUptime % 60).padStart(2, '0')})
        </span>
      )}
    </div>
  )
}
